export const QUIZ_CATEGORY_META_REQUEST = 'QUIZ_CATEGORY_META_REQUEST'
export const QUIZ_CATEGORY_META_SUCCESS = 'QUIZ_CATEGORY_META_SUCCESS'
export const QUIZ_CATEGORY_META_FAILURE = 'QUIZ_CATEGORY_META_FAILURE'
